export default "__VITE_ASSET__CuST3sw3__"